export async function downloadBalanceHistoryUseCase(client_id, initial_date, final_date, guideRepostitory) {
    const result = await guideRepostitory.donwload_balance_report(client_id, initial_date, final_date);

    return result;
}